import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import { required } from '../../../../utils/validations';
import FirstOptionComponent from './FirstOptionComponent';
import SecondOptionComponent from './SecondOptionComponent';
import ThirdOptionComponent from './ThirdOptionComponent';
import PropTypes from 'prop-types';

class StepThreeComponent extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount() {
    const { fetchObject } = this.props;
    let objectId = localStorage.getItem('object_id');
    if (objectId !== 'undefined') {
      fetchObject(objectId);
    }
  }

  render() {
    const { handleSubmit, pristine, submitting, isloading, formErrors } = this.props;

    let content = null;

    // check boat type from localStorage
    let type_of_boat = localStorage.getItem('object');

    if (type_of_boat === 'Boat') {
      content = <ThirdOptionComponent {...this.props}/>
    } else if (type_of_boat === 'Woonboot') {
      content = <FirstOptionComponent {...this.props}/>
    } else {
      content = <SecondOptionComponent {...this.props}/>
    }

    return (
      <React.Fragment>
        {content}
      </React.Fragment>
    );
  }
}

StepThreeComponent.propTypes = {
  isloading: PropTypes.bool,
  initialValues: PropTypes.object,
  formErrors: PropTypes.object
}

export default StepThreeComponent;

